<template>
    <v-container fluid>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
        <v-form ref="logForm" v-model="valid"  >
            <v-row class="mt-1">
                <v-col>
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                    <v-menu
                        v-if="!loading"
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field 
                                outlined
                                dense
                                v-model="form.from_date"
                                :label="$store.getters.getTextMap().from_date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules="objectRules"
                                :dark="$store.getters.getColorPalette().isDark" 
                            ></v-text-field>
                        </template>
                        <v-date-picker   
                            :dark="$store.getters.getColorPalette().isDark" 
                            v-model="form.from_date"
                            @input="menu = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                    <v-menu   
                        :dark="$store.getters.getColorPalette().isDark" 
                        v-if="!loading"
                        ref="menufrom"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="fromTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field  :dark="$store.getters.getColorPalette().isDark" 
                                v-model="fromTime"
                                outlined
                                dense
                                :label="$store.getters.getTextMap().from"
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules="objectRules"
                            ></v-text-field>
                        </template>
                        <v-time-picker   :dark="$store.getters.getColorPalette().isDark" 
                        v-if="menu3"
                        v-model="fromTime"
                        full-width
                        format="24hr"
                        @click:minute="$refs.menufrom.save(fromTime)"
                        ></v-time-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                    <v-menu
                        v-if="!loading"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field 
                                v-model="form.to_date"
                                :label="$store.getters.getTextMap().to_date"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                v-bind="attrs"
                                v-on="on"
                                :rules="objectRules"
                                :dark="$store.getters.getColorPalette().isDark" 
                            ></v-text-field>
                        </template>
                        <v-date-picker   
                            :dark="$store.getters.getColorPalette().isDark" 
                            v-model="form.to_date"
                            @input="menu1 = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text" ></v-skeleton-loader>
                    <v-menu    
                        :dark="$store.getters.getColorPalette().isDark" 
                        v-if="!loading"
                        ref="menuto"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="toTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field  :dark="$store.getters.getColorPalette().isDark" 
                            v-model="toTime"
                            outlined
                            dense
                            :label="$store.getters.getTextMap().to"
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="objectRules"
                        ></v-text-field>
                        </template>
                        <v-time-picker
                            v-if="menu2"
                            v-model="toTime"
                            full-width
                            format="24hr"
                            @click:minute="$refs.menuto.save(toTime)"
                        ></v-time-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text" ></v-skeleton-loader>
                    <v-btn
                        v-if="!loading"
                        small
                        text
                        :color="$store.getters.getColorPalette().submitbtnColor"
                        outlined
                        @click="onSubmit"
                    >
                        {{ $store.getters.getTextMap().fetch_logs }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-row no-gutters>
            <v-col cols="12">
                <v-card  :dark="$store.getters.getColorPalette().isDark" >
                    <v-data-table
                        :headers="headers"
                        :items="logs"
                        item-key="incident_id"
                        show-expand
                        :expanded.sync="expanded"
                        :loading="loading"
                        loading-text="Loading... Please wait"
                        :dark="$store.getters.getColorPalette().isDark" 
                    >
                        <template v-slot:expanded-item="{ headers, item }">
                            <!-- <td  v-if="!editMode">
                                <v-btn
                                    v-if="!loading"
                                    small
                                    text
                                    :color="$store.getters.getColorPalette().accentCode"
                                    outlined
                                    @click="editMode=!editMode"
                                >
                                    {{ $store.getters.getTextMap().edit }}
                                </v-btn>
                            </td> -->
                            <td v-if="editMode" :colspan="headers.length">
                                <WriteSafetyIncident :safetyIncidentDetails="item" v-on:success="onSubmit"/>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>    
    </v-container>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import InfoAlert from '@/components/InfoAlert'
import WriteSafetyIncident from '@/components/crud_components/manufacturing/WriteSafetyIncident'
export default {
    name:'SafetyIncidentLogDetails',
    components:{
        InfoAlert,
        WriteSafetyIncident
    },
    mounted(){
        this.form.from_date=moment().subtract(30,'days').format('YYYY-MM-DD')
        this.form.to_date=moment().add(3,'days').format('YYYY-MM-DD')
        this.toTime='23:59'
        this.fromTime='00:00'
        this.onSubmit()
    },
        data(){
            return {
                editMode:true,
                search:'',
                valid:false,
                menu:false,
                menu1:false,
                menu2:false,
                menu3:false,
                graphData:[],
                toTime:null,
                fromTime:null,
                showDismissibleAlert:false,
                loading:false,
                info:'',
                expanded: [],
                logs:[],
                form:{
                    from_date:null,
                    to_date:null,
                },
                headers: [
                    {
                        text: 'Date',
                        align: 'start',
                        filterable: false,
                        value: 'timestamp',
                        class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName
                    },
                    { text: 'Location', value: 'location_id', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Employee Id', value: 'employee_id', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Incident Description', value: 'description', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Severity', value: 'severity', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Accident', value: 'accident', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Accident With Loss', value: 'accident_with_loss', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Corrective Action', value: 'corrective_action', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Closed', value: 'closed', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                    { text: 'Logged By', value: 'logged_by', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                ],
                objectRules:[
                    v => !!v || 'Required',
                ],
            }
        },
        computed:{
            fromTimeStamp(){
            if(this.form.from_date){
                let dt=this.form.from_date.toString()
                if(this.fromTime){
                  dt+=' '+this.fromTime.toString()
                  return Number(moment(dt,'YYYY-MM-DD HH:mm').format("X"));
                }
                return Number(moment(dt,'YYYY-MM-DD').format("X"));
            }else{
              return null
            }
          },
          toTimeStamp(){
            if(this.form.to_date){
                let dt=this.form.to_date.toString()
                if(this.toTime){
                  dt+=' '+this.toTime.toString()
                }else{
                    dt+=' 23:59'
                }
                return Number(moment(dt,'YYYY-MM-DD HH:mm').format("X"));
            }else{
              return null
            }
          },
        },
        methods: {
            onSubmit(){
                this.$refs.logForm.validate()
                if(this.valid){
                  this.loading=true
                  let payload={
                        from_timestamp:this.fromTimeStamp,
                        to_timestamp:this.toTimeStamp
                    }
                    axios.post(this.$store.state.api+'getSafetyIncidentLogDataBetweenTimestamp',payload,{headers: {Authorization: 'Bearer '+ this.$store.state.jwt}})
                    .then(response=>{
                        if(response.data.status==='success'){
                            let data=[]
                            let index=0
                            for (let i of response.data.data){
                                let location_details=this.$store.getters.getLocationById(i.location_id)
                                i['timestamp'] = moment.unix(i['timestamp']).format('YYYY-MM-DD:HH:mm');
                                i['location_id'] = location_details.location_name;
                                i['index']=index++
                                data.push(i)
                            }
                            this.logs=data
                            if(this.logs.length==0){
                                this.info = "No data to show";
                                this.showDismissibleAlert = true;
                            }
                        }else{
                            this.info = response.data.msg;
                            this.showDismissibleAlert = true;
                        }
                        this.loading=false
                    }).catch(err=>{
                        this.showDismissibleAlert=true
                        this.info=err
                        this.loading=false
                    })
                }
            }
        },
    }
</script>